export default __webpack_public_path__ + "static/media/area-69.da1c66dc.jpg";